import { get } from '@/utils/request'
import useSWR from 'swr'
import { roomType, roundDataType, turnType } from '@/utils/types'
import { decrypt, getMatchEncryptedKey } from '@/utils/crypto'
import { commonSWROptions, focusedSWROptions } from './useAdmin'

const fetchRelatedRooms = (match_id: string, turn: turnType, match_type) => {
  let path = 'users/rooms/gd_related_rooms'
  if (match_type === 'league') {
    path = 'users/rooms/gd_rooms'
  }
  return get(path, { match_id, turn }).then((res) => {
    if (res.ok) {
      return res.rooms.map((room) => ({ ...room, status: room.status ?? 10 }))
    }
    return []
  })
}
export const useRelatedRooms = (match_id, turn, match_type, is_online_game = false) => {
  return useSWR(match_id && match_type ? `rooms-related-${match_id}-${turn}` : undefined, () => fetchRelatedRooms(match_id, turn, match_type), {
    fallbackData: [],
    ...commonSWROptions,
    refreshInterval: is_online_game ? 60000 : 900000,
  }) as {
    data: roomType[]
    mutate: any
    isValidating: boolean
  }
}

const fetchRooms = (match_id: string, turn: turnType, is_encrypted = false) =>
  get('users/rooms/gd_rooms', { match_id, turn }).then((res) => {
    if (res.ok) {
      let rooms = res.rooms.map((room) => ({ ...room, status: room.status ?? 10 }))
      if (is_encrypted) {
        const key = getMatchEncryptedKey(match_id)
        if (key) {
          rooms = rooms.map((r) => {
            if (r.team1_user1) r.team1_user1 = decrypt(r.team1_user1, key)
            if (r.team1_user2) r.team1_user2 = decrypt(r.team1_user2, key)
            if (r.team2_user1 && r.team2_user1 !== '空') r.team2_user1 = decrypt(r.team2_user1, key)
            if (r.team2_user2 && r.team2_user2 !== '空') r.team2_user2 = decrypt(r.team2_user2, key)
            return r
          })
          return rooms
        }
      }
      return rooms
    }
    return []
  })

const useRooms = (match_id, turn, is_encrypted = false) => {
  return useSWR(match_id ? `rooms-${match_id}-${turn}` : null, () => fetchRooms(match_id, turn, is_encrypted), {
    fallbackData: [],
    ...commonSWROptions,
  }) as {
    data: roomType[]
    mutate: any
    isValidating: boolean
  }
}

const fetchRoom = (roomID) =>
  get(`users/rooms/${roomID}`).then((res) => {
    if (res.ok) {
      return res
    }
    return { round: {}, room: {} }
  })

export const useRoom = (roomID: string, turn?: string) => {
  return useSWR(roomID ? `room-${roomID}-${turn}` : null, () => fetchRoom(roomID), { fallbackData: { round: {}, room: {} }, ...focusedSWROptions }) as {
    data: { round: roundDataType; room: roomType }
    mutate: any
  }
}

export default useRooms
